<template>
  <div>
    <div class="java110_step">
      <el-steps :active="activeStep" finish-status="success">
        <el-step title="选择服务"></el-step>
        <el-step title="开发服务实现"></el-step>
        <el-step title="备注信息"></el-step>
      </el-steps>
    </div>

    <!-- 选择 应用信息 -->
    <div v-if="activeStep == 0">
      <view-service-info 
        ref="viewServiceInfo"
        @notify="handleNotify">
      </view-service-info>
    </div>
    <div v-if="activeStep == 1">
      <dev-service-provide-view
        ref="devServiceProvideView"
        @notify="handleNotify">
      </dev-service-provide-view>
    </div>
    <div v-if="activeStep == 2">
      <service-provide-remark-view
        ref="serviceProvideRemarkView"
        @notify="handleNotify">
      </service-provide-remark-view>
    </div>

    <el-row>
      <el-col :span="22" :offset="2">
        <div style="margin-bottom:10px; text-align:right">
          <el-button @click="prevStep" plain>
            {{ $t('devServiceProvide.prevStep') }}
          </el-button>
          <el-button 
            v-if="activeStep != 2" 
            type="primary" 
            style="margin-left:10px;" 
            @click="nextStep">
            {{ $t('devServiceProvide.nextStep') }}
          </el-button>
          <el-button 
            v-if="activeStep == 2" 
            type="primary" 
            style="margin-left:10px;" 
            @click="finishStep">
            {{ $t('devServiceProvide.finish') }}
          </el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import ViewServiceInfo from '@/components/dev/viewServiceInfo/viewServiceInfo.vue'
import DevServiceProvideView from '@/components/dev/devServiceProvideView/devServiceProvideView.vue'
import ServiceProvideRemarkView from '@/components/dev/serviceProvideRemarkView/serviceProvideRemarkView.vue'
import { saveServiceProvide } from '@/api/dev/serviceApi'

export default {
  name: 'DevServiceProvide',
  components: {
    ViewServiceInfo,
    DevServiceProvideView,
    ServiceProvideRemarkView
  },
  data() {
    return {
      activeStep: 0,
      stepInfos: []
    }
  },
  methods: {
    handleNotify(info) {
      console.log(info);
      this.stepInfos[this.activeStep] = info
    },
    prevStep() {
      if (this.activeStep > 0) {
        this.activeStep--
      }
    },
    nextStep() {
      const currentData = this.stepInfos[this.activeStep]
      if (!currentData) {
        this.$message.warning(this.$t('devServiceProvide.requiredInfo'))
        return
      }
      this.activeStep++
    },
    async finishStep() {
      const currentData = this.stepInfos[this.activeStep]
      if (!currentData) {
        this.$message.warning(this.$t('devServiceProvide.requiredInfo'))
        return
      }

      try {
        const param = {
          data: this.stepInfos
        }
        await saveServiceProvide(param)
        this.$message.success(this.$t('devServiceProvide.success'))
        this.$router.go(-1)
      } catch (error) {
        this.$message.error(error.message || this.$t('devServiceProvide.error'))
      }
    }
  }
}
</script>

<style scoped>
.java110_step {
  margin-bottom: 20px;
}
</style>